import { render, staticRenderFns } from "./CreateBtn.vue?vue&type=template&id=015b1b6a&lang=pug&"
import script from "./CreateBtn.vue?vue&type=script&lang=js&"
export * from "./CreateBtn.vue?vue&type=script&lang=js&"
import style0 from "./CreateBtn.vue?vue&type=style&index=0&id=015b1b6a&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('015b1b6a')) {
      api.createRecord('015b1b6a', component.options)
    } else {
      api.reload('015b1b6a', component.options)
    }
    module.hot.accept("./CreateBtn.vue?vue&type=template&id=015b1b6a&lang=pug&", function () {
      api.rerender('015b1b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/interface/CreateBtn.vue"
export default component.exports